import { Trash2, Disc3 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const HistoryList = ({ songs, activeId, onSelect, onDelete }) => {
  if (!songs?.length) {
    return (
      <div className="border border-white/10 bg-zinc-900/40 p-5 rounded-sm">
        <div className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">
          history // empty
        </div>
        <p className="text-sm text-zinc-500">
          Your decoded tracks will appear here.
        </p>
      </div>
    );
  }

  return (
    <div className="border border-white/10 bg-zinc-900/40 rounded-sm" data-testid="history-list">
      <div className="px-4 py-3 border-b border-white/5 flex items-center justify-between">
        <span className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500">
          history // {songs.length}
        </span>
      </div>
      <div className="max-h-[520px] overflow-y-auto">
        {songs.map((s) => (
          <div
            key={s.id}
            onClick={() => onSelect(s)}
            data-testid={`history-item-${s.id}`}
            className={`px-4 py-3 border-b border-white/5 cursor-pointer transition-colors group ${
              activeId === s.id ? "bg-emerald-500/10 border-l-2 border-l-emerald-500" : "hover:bg-white/5"
            }`}
          >
            <div className="flex items-start gap-3">
              <Disc3 className={`w-4 h-4 mt-0.5 flex-shrink-0 ${activeId === s.id ? "text-emerald-500" : "text-zinc-500"}`} />
              <div className="flex-1 min-w-0">
                <div className="font-mono-display text-sm text-white truncate">{s.title}</div>
                <div className="font-mono-display text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-0.5">
                  {s.genre} · {s.bpm}
                </div>
              </div>
              <Button
                onClick={(e) => { e.stopPropagation(); onDelete(s.id); }}
                data-testid={`delete-song-${s.id}`}
                variant="ghost"
                size="icon"
                className="h-6 w-6 opacity-0 group-hover:opacity-100 hover:bg-red-500/20 hover:text-red-400 rounded-none"
              >
                <Trash2 className="w-3 h-3" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
